import { getFetch } from '../fetch';
import { apiConfig } from '../config';

import { SearchData } from '../../../typings';

interface QueryParams {
    [key: string]: unknown; // отформатированная бункерная нода subjectConfig.search_namespace_by_grade[].query
}

interface SearchParams extends QueryParams {
    text: string;
    namespaceIds: number[]; // бункерная нода subjectConfig.search_namespace_by_grade[].namespace_ids
    isFullText?: boolean;
}

export function getSearchData({ text, namespaceIds, isFullText, ...params }: SearchParams): Promise<SearchData> {
    const { apiGetSearchData } = apiConfig.getStaticUrls();

    return getFetch(apiGetSearchData, {
        text: isFullText ? text : `${text}*`,
        kps: namespaceIds.join(','),
        ...params,
    });
}
